export default "__VITE_ASSET__rfKLwy9x__"